import React from "react";

import Breadcrumbs from "../../../../components/BreadCrumbs";
import {
  UIPageFormFooter,
  UIPhoneField,
  UISelect,
  UITextField,
  UIUpload,
} from "../../../../components/ui";
import useAdminAddEmployee from "../hooks/useAdminAddEmployee";

import "../../../Company-portal/TeamsPermissions/AddEmployee/AddEmployee.scss";

const AdminAddEmployee = () => {
  const {
    copy,
    breadcrumbList,
    name,
    setName,
    email,
    setEmail,
    phone,
    setPhone,
    setPhoneCountryDialCode,
    role,
    setRole,
    roleOptions,
    pictureFile,
    picturePreview,
    setPictureFile,
    setPicturePreview,
    uploadState,
    uploadingPicture,
    busy,
    showError,
    markTouched,
    errors,
    isFormValid,
    goBackToList,
    handleSubmit,
  } = useAdminAddEmployee();

  return (
    <div className="team-management add-employee">
      <div className="mt-2">
        <Breadcrumbs list={breadcrumbList} BreadCrumbHasBackIcon={false} />
      </div>

      <div className="add-employee__card">
        <div className="add-employee__card-header">{copy.detailsTitle}</div>

        <div className="add-employee__card-body">
          <div className="add-employee__avatar-col">
            <UIUpload
              name="profilePicture"
              className="add-employee__avatar"
              variant="logo"
              label={copy.pictureLabel}
              uploadText={copy.uploadPicture}
              changeText={copy.changePicture}
              preview={picturePreview || ""}
              file={pictureFile}
              showRemove
              isUploading={uploadingPicture}
              uploadProgress={uploadingPicture ? uploadState.percent : undefined}
              uploadProgressLabel={
                uploadingPicture
                  ? `${copy.uploading} · ${uploadState.percent}%`
                  : null
              }
              onChange={(file, preview) => {
                if (!file) {
                  setPictureFile(null);
                  setPicturePreview(null);
                  return;
                }
                setPictureFile(file);
                setPicturePreview(typeof preview === "string" ? preview : null);
              }}
              disabled={busy}
            />
          </div>

          <div className="add-employee__grid">
            <UITextField
              label={copy.fields.name}
              name="name"
              required
              value={name}
              placeholder={copy.fields.namePlaceholder}
              onChange={(event) => setName(event.target.value)}
              onBlur={() => markTouched("name")}
              error={showError("name")}
              helperText={showError("name") ? errors.name : null}
            />
            <UITextField
              label={copy.fields.email}
              name="email"
              required
              value={email}
              placeholder={copy.fields.emailPlaceholder}
              onChange={(event) => setEmail(event.target.value)}
              onBlur={() => markTouched("email")}
              error={showError("email")}
              helperText={showError("email") ? errors.email : null}
            />
            <UIPhoneField
              label={copy.fields.mobileNumber}
              name="mobileNumber"
              country="sa"
              preferredCountries={["eg", "sa", "ae"]}
              value={phone}
              formValueIsFullInternational
              onChange={(fullValue, countryData) => {
                setPhone(fullValue);
                const dc = countryData?.dialCode;
                if (dc != null && dc !== "") {
                  setPhoneCountryDialCode(String(dc).replace(/\D/g, ""));
                }
              }}
            />
            <UISelect
              label={copy.fields.role}
              name="role"
              required
              placeholder={copy.fields.rolePlaceholder}
              options={roleOptions}
              value={role}
              onChange={(nextValue) => setRole(nextValue)}
              onBlur={() => markTouched("role")}
              error={showError("role")}
              helperText={showError("role") ? errors.role : null}
            />
          </div>
        </div>
      </div>

      <UIPageFormFooter
        cancelLabel={copy.cancel}
        submitLabel={copy.submit}
        onCancel={goBackToList}
        onSubmit={handleSubmit}
        cancelDisabled={busy}
        submitDisabled={busy || !isFormValid}
        submitLoading={busy}
      />
    </div>
  );
};

export default AdminAddEmployee;
